/**
 * Resolves the initial value for the alt entities modal.
 * If data-alt-entities has a stored JSON string, parses it.
 * If data-alt-entities is empty but alt has a value, falls back to alt (backwards compatibility).
 */
export const resolveAltEntitiesValue = (
  dataAltEntities: string | undefined | null,
  alt: string | undefined | null,
): any => {
  let parsedValue: any = dataAltEntities;
  if (typeof dataAltEntities === 'string' && dataAltEntities) {
    try {
      parsedValue = JSON.parse(dataAltEntities);
    } catch {
      parsedValue = dataAltEntities;
    }
  }
  // Backwards compatibility: if data-alt-entities is empty but alt has a value,
  // use the plain alt text as the initial value
  if (!parsedValue && alt) {
    parsedValue = alt;
  }
  return parsedValue || '';
};
